import React, { useEffect, useState } from "react";
import { Row, Col, Button, Input } from "antd";
import styled from "styled-components";
import { Select, Space } from "antd";
import { Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Table } from "antd";
import { ReactComponent as TrashIcon } from "../../../assets/Icons/Trashfull.svg";
import { ReactComponent as EditpencilIcon } from "../../../assets/Icons/Editpencil.svg";
import { useNavigate } from "react-router-dom";
import Createformpeople from "../../Pages/People/Createform";
import FetchData from "../../../hooks/FetchData";
import PostUpdateData from "../../../hooks/postUpdate";
import { useSelector } from "react-redux";
import { message } from "antd";

// Fonts/sizes/colours match the Messages and Group modules: DM Sans,
// 20px/500 page title, mint action button, 14px table with 16px cells.
const Neewcontainer = styled.div`
  font-family: "DM Sans", sans-serif;

  .people_headin {
    font-family: "DM Sans", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    color: #1f243b;
    text-align: left;
    margin: 0;
  }
  /* "Total People: N" - a count under the title, not a second heading. */
  .people_count {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #636980;
  }
  .Create_Newpeople {
    height: 40px;
    padding: 0 20px;
    border-radius: 8px;
    background-color: #c2fae5;
    color: #1f243b;
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
  }
  .Create_Newpeople:hover {
    background-color: #c2fae5 !important;
  }
  .people_main_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 16px 0;
  }
  .search_icon_dropdown {
    border-radius: 19px;
  }

  .ant-select-selector {
    border-radius: 18px;
  }
  .ant-table {
    font-family: "DM Sans", sans-serif;
  }
  /* Beats antd's size="small" cell padding, which is more specific. */
  .ant-table-wrapper .ant-table .ant-table-thead > tr > th,
  .ant-table-wrapper .ant-table .ant-table-tbody > tr > td {
    padding: 16px;
    font-size: 14px;
  }
  .ant-table-thead > tr > th {
    font-weight: 600;
    color: #1f243b;
    background: #fafafa;
  }
  .ant-table-tbody > tr > td {
    color: #636980;
  }
  /* Name column reads as the row's main label. */
  .ant-table-tbody > tr > td:nth-child(2) {
    color: #1f243b;
  }
  .custom_table_border {
    border: 1px solid #e2e2e9;
    border-radius: 8px;
    overflow: hidden;
  }
  .container_icon_delete_edit {
    display: flex;
    gap: 5px;
  }

  .custom_table_border .ant-table {
    border-left: 0px solid #d9d9d9;
    border-right: 0px solid #d9d9d9;
  }
`;

const PeopleMenu = ({ endPoint }) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const navigate = useNavigate();
  console.log("hoveredRow===>", hoveredRow);
  const [people, setPeople] = useState([]);

  const userInfo = useSelector(function (state) {
    return state.authTracking.userInfo;
  });
  // const fetchPeople = async()=> {
  //   try{
  // const data = await FetchData({endPoint:"https://bxge5lc56l.execute-api.ap-south-1.amazonaws.com/Prod/people/adduser/MOJR3BK"})
  // setPeople(data)
  // console.log("data===> " , data)
  //   }
  //   catch(error){
  //     console.error("Error fetching people:", error);

  //   }

  // }

  const handleGetCustomData = async () => {
    const endpoint = `/people/getuser/${userInfo.clientId}`;
    try {
      const response = await FetchData({ endPoint: endpoint });

      if (response?.statusCode === 200 && Array.isArray(response?.response)) {
        const formattedData = response.response.map((item) => ({
          // Spread the raw row first so every real column (first_name,
          // last_name, bio, user_name, active, etc.) survives - Edit needs
          // the full record, not just these display-only aliases.
          ...item,
          key: item.people_id,
          people_id: item.people_id,
          Employeeid: item.people_id,
          name: `${item.first_name || ""} ${item.last_name || ""}`.trim() || "—",
          Emailid: item.email || "—",
          Peopletype: item.peopel_type || "—",
          Addedon: item.created_at
            ? new Date(item.created_at).toLocaleDateString()
            : "—",
          // There's no last-login tracking in tymeplushrlmspeople yet.
          Lastlogin: "—",
        }));
        setPeople(formattedData);
      } else {
        setPeople([]);
      }
    } catch (error) {
      console.error("error", error);
      message.error("Failed to load people");
    }
  };

  useEffect(() => {
    if (!userInfo?.clientId) return;
    handleGetCustomData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.clientId]);

  const selectedoptions = [
    {
      value: "",
      label: "",
    },
    {
      value: "",
      label: "",
    },
    {
      value: "",
      label: "",
    },
    {
      value: "",
      label: "",
      disabled: true,
    },
  ];

  const handleChange = (value) => {
    console.log("values from form ====>", `selected ${value}`);
  };

  function handleEdit(record) {
    navigate("/Createformpeople", { state: record });
  }

  async function handleDelete(record) {
    try {
      await PostUpdateData({
        endPoint: `/people/deleteuser/${userInfo.clientId}/${record.people_id}`,
        method: "DELETE",
      });
      message.success("Person deleted");
      setPeople((prev) => prev.filter((p) => p.people_id !== record.people_id));
    } catch (error) {
      console.error("Delete person error:", error);
      message.error("Failed to delete person");
    }
  }

  const columns = [
    {
      title: "Employee Id",
      dataIndex: "Employeeid",
      key: "Employeeid",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email Id",
      dataIndex: "Emailid",
      key: "Emailid",
    },
    {
      title: "People type",
      dataIndex: "Peopletype",
      key: "Peopletype",
    },
    {
      title: "Added on",
      dataIndex: "Addedon",
      key: "Addedon",
    },
    {
      title: "Last Login",
      dataIndex: "Lastlogin",
      key: "Lastlogin",
    },

    {
      title: "",
      dataIndex: "",
      key: "",
      render: (_, record) => (
        <div
          className="container_icon_delete_edit"
          onClick={(e) => e.stopPropagation()}
        >
          <EditpencilIcon
            style={{ marginRight: 16, cursor: "pointer" }}
            onClick={() => handleEdit(record)}
          />
          <TrashIcon
            style={{ marginRight: 16, cursor: "pointer" }}
            onClick={() => handleDelete(record)}
          />
        </div>
      ),
    },
  ];

  function handlenavigatepeople() {
    console.log("am been clicked !");
    navigate("/Createformpeople");
  }

  function handleRowClick(record) {
    console.log("record=====>", record);
    navigate("/Createformpeople", { state: record });
  }
  return (
    <>
      <Neewcontainer>
        <Row gutter={16}>
          <Col xl={24} xs={24}>
            <div className="people_main_container">
              <p className="people_headin">People</p>
              <Button
                type="text"
                onClick={handlenavigatepeople}
                className="Create_Newpeople"
              >
                + Create Newpeople
              </Button>
            </div>
          </Col>
        </Row>
      </Neewcontainer>
      <Neewcontainer>
        <Row gutter={[16, 16]}>
          <Col xl={24} xs={24}>
            <Form>
              <div className="people_main_container">
                <p className="people_count">Total People: {people.length}</p>

                <Select
                  className="search_icon_dropdown"
                  showSearch
                  placeholder={
                    <Input
                      placeholder="Search"
                      prefix={<SearchOutlined />}
                      style={{ border: "none", outline: "none" }}
                    />
                  }
                  optionFilterProp="children"
                  suffixIcon={null}
                ></Select>
              </div>
            </Form>
          </Col>
        </Row>
      </Neewcontainer>

      <Neewcontainer>
        <div>
          <Table
            dataSource={people}
            size="small"
            pagination={false}
            columns={columns}
            className="custom_table_border"
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
              onMouseEnter: () => setHoveredRow(record.key),
              onMouseLeave: () => setHoveredRow(null),
            })}
          />
        </div>
      </Neewcontainer>
    </>
  );
};

export default PeopleMenu;
